import type { PblCase } from '@/types/pbl';
import { PBL_UTC_OFFSET } from '@/utils/pblDate';
import { canClosePblCase, canClosePblCaseStatus } from './caseProgressState';

const timestamp = (value?: string | null) => {
  if (!value) return NaN;
  const normalized = value.trim().replace(' ', 'T');
  return Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized) ? normalized : `${normalized}${PBL_UTC_OFFSET}`);
};

export const isPblCaseClosureDue = (caseData: PblCase, user: unknown, now = Date.now()) => {
  if (caseData.closed_at || caseData.cancelled_at || !canClosePblCaseStatus(caseData.status) || !canClosePblCase(caseData, user)) return false;
  // The list uses a server aggregate; detail uses the authoritative meeting collection after edits.
  const ends = caseData.meetings
    ? caseData.meetings
        .filter((meeting) => meeting.purpose === 'lawyer_consultation' && ['scheduled', 'completed'].includes(meeting.status || ''))
        .map((meeting) => timestamp(meeting.ends_at)).filter(Number.isFinite)
    : [timestamp(caseData.latest_consultation_ends_at)].filter(Number.isFinite);
  return ends.length > 0 && Math.max(...ends) <= now;
};
